 <!-- To Do list 
Update stock count 
 -->
 <template>
 <div>
	 <v-select v-model="product" label="name" class="w-full primary" name="product" :options="products" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
  <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
 		<div v-if="Object.keys(selectedProduct).length !== 0" class="p-6">
		 <h4 class="mt-8">General Infomation</h4>
        <!-- NAME -->
        <vs-input label="Name" v-model="selectedProduct.name" class="mt-5 w-full" name="name" v-validate="{required: true}" data-vv-validate-on="blur" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

         <!-- Description -->
        <div class="mt-5">
          <label class="vs-input--label">Product Description</label>
          <vs-textarea name="desciption" v-model="selectedProduct.description" counter="255" v-validate="{required: true}" :counter-danger.sync="counterDanger" data-vv-validate-on="blur" />
          <span class="text-danger text-sm" v-show="errors.has('desciption')">{{ errors.first('desciption') }}</span>
        </div>

        <!-- CATEGORY -->
				<label class="vs-input--label">Product Category</label>
				<v-select label="name" v-model="selectedProduct.category_name" class="w-full primary" name="category" :options="getCategory" v-validate="{required: true}" :dir="$vs.rtl ? 'rtl' : 'ltr'" data-vv-validate-on="blur">
				</v-select>
        <span class="text-danger text-sm" v-show="errors.has('category')">{{ errors.first('category') }}</span>


        <!-- PRODUCT CONDITION -->
        <div class="w-full mt-5 vx-row justify-between">
         <div class="vx-col">
          <label class="vs-input--label">Product Condition</label>
          <vx-tooltip text="This is to indicates the item's condition.">
            <vs-switch v-model="selectedProduct.condition" style="width: 60px;">
              <span slot="on">New</span>
              <span slot="off">Used</span>
            </vs-switch>
          </vx-tooltip>
        </div>
        </div>
			
				<h4 class="mt-8">Product Variant Infomation</h4>
        <!-- VARIANT -->
        <div class="w-full mt-5 vx-row">
					<div class="vx-col">
          <label class="vs-input--label">Product Variant</label>
          <vx-tooltip text="This product contained more than 1 option.">
          <vs-switch @change="initOptions" v-model="selectedProduct.product_variant" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check" vs-value=true style="width: 60px;">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
          </vs-switch>
          </vx-tooltip>
          </div>
        </div>

				<!-- Variant One Enable Mode -->
				<div v-if="selectedProduct.product_variant && selectedProduct.variant.length === 0" class="variant-container">
					<div v-show="!selectedProduct.isEnableRootSetting" class="p-3 mt-3 text-center align-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="addNewRootVariant">
							<feather-icon icon="PlusCircleIcon" svgClasses="h-4 w-4" />
							<span class="ml-2 mt-1 text-base text-primary">Enable Variation 1</span>
					</div>
				</div>

				<!-- Variant One  -->
				<div v-if="selectedProduct.variant.length > 0" class="variant-container">
					<feather-icon v-show="selectedProduct.isEnableRootSetting" icon="XIcon" @click="initConfirm('root')" class="cross-icon cursor-pointer"></feather-icon>
					<div>
						<h5 class="mb-3">Variation 1</h5>
							<label class="vs-input--label">Option Name</label>
							<vs-input class="mb-5" ref="others" vid="others" v-model="selectedProduct.variant[0].label" @keyup="sync_labelling(1)" name="others" placeholder="Color" v-validate="{ required: true }" data-vv-validate-on="blur" />
							<span class="text-danger text-sm" v-show="errors.has('others')">{{ errors.first('others') }}</span>

							<div>
								<label class="vs-input--label">Option Value</label>
							</div>
							<div class="form-group vx-row" v-for="(option, index) in selectedProduct.variant" :key="index">
								<vs-input
								vid="option" 
								class="vx-col" 
								v-model="option.value" 
								placeholder="eg: Red" 
								v-validate="{required: true,is_not: option}" 
								:name="'variant 1 option '+(index+1)" 
								data-vv-validate-on="blur"
								ref="option"/> 
								<feather-icon class="cursor-pointer vx-col" icon="Trash2Icon" svgClasses="h-4 w-4" @click="removeRoot(index)"/>
								<span class="text-danger text-sm mt-3">{{ errors.first(`${'variant 1 option '+(index+1)}`) }}</span>
							</div>
							<div class="p-3 mt-3 w-3/4 text-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="addRootVariant" >
								<feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
								<span class="ml-2 text-base text-primary">Add {{selectedProduct.variant[0].label == '' ? 'Option' : selectedProduct.variant[0].label}}</span>
							</div>
					</div>
				</div>

				<!-- Variant Two Enable Mode-->
				<div v-if="selectedProduct.isEnableRootSetting && selectedProduct.variant[0].option.length === 0" class="variant-container">
					<div v-show="!selectedProduct.isEnableTreeSetting" class="p-3 mt-3 text-center align-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="addNewTreeVariant">
							<feather-icon icon="PlusCircleIcon" svgClasses="h-4 w-4" />
							<span class="ml-2 mt-1 text-base text-primary">Enable Variation 2</span>
					</div>
				</div>

				<!-- Variant Two  -->
				<div v-if="selectedProduct.isEnableRootSetting && selectedProduct.variant[0].option.length > 0" class="variant-container">
					<feather-icon v-show="selectedProduct.isEnableTreeSetting" icon="XIcon" @click="initConfirm('tree')" class="cross-icon cursor-pointer"></feather-icon>
					<div>
						<h5>Variation 2</h5>
							<label class="vs-input--label">Option Name</label>
							<vs-input class="mb-5" ref="others2" v-model="selectedProduct.variant[0].option[0].label" @keyup="sync_labelling(2)" placeholder="Size" name="others2" data-vv-validate-on="blur" v-validate="{required_if:'isEnableTree,true',is_not: others}" />
							<span class="text-danger text-sm" v-show="errors.has('others2')">{{ errors.first('others2') }}</span>

							<div>
								<label class="vs-input--label">Option Value</label>
							</div>
								<div class="form-group vx-row" v-for="(option, index) in selectedProduct.variant[0].option" :key="index">
									<vs-input 
									class="vx-col" 
									v-model="option.value" 
									placeholder="eg: S" 
									v-validate="'min:1'" 
									:name="'variant 2 option '+(index+1)" 
									data-vv-validate-on="blur"
									ref="option2"
									@input="syncInput"/> 
									<feather-icon class="cursor-pointer vx-col" icon="Trash2Icon" svgClasses="h-4 w-4" @click="removeTree(index)"/>
									<span class="text-danger text-sm mt-3">{{ errors.first(`${'variant 2 option '+(index+1)}`) }}</span>
								</div>

								<div class="p-3 mt-3 w-3/4 text-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="addTreeVariant">
									<feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
									<span class="ml-2 text-base text-primary">Add {{others2 == '' ? 'Option' : others2}}</span>
								</div>
					</div>
				</div>
				
				<!-- Apply All -->
				<div v-show="selectedProduct.isEnableRootSetting || selectedProduct.isEnableTreeSetting" class="apply-all-container">
					<div class="apply-all-info">
					<feather-icon class="mr-2" icon="InfoIcon" svgClasses="h-5 w-5"/>
					<span class="mb-2">Tips: You may directly apply all the values to variation summary table by key in them under these three text fields.</span>
					</div>
					<div class="apply-all-label">
						<label class="vs-input--label">Price(RM)</label>
						<!-- <label class="vs-input--label">Stock</label> -->
						<label class="vs-input--label">SKU</label>
						<label class="vs-input--label">Volumetric(KG)</label>
						<label class="vs-input--label">Weight(KG)</label>
					</div>


					<div class="apply-all-form">
						<vs-input class="data-input-table w-1/4" @focus="hoverPrice = true" @blur="hoverPrice = false" v-model="allPrice" name="allPrice" data-vv-validate-on="blur" v-validate="{regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" />
						<!-- <vs-input class="data-input-table w-1/4" @focus="hoverStock = true" @blur="hoverStock = false" v-model="allStock" name="allStock" data-vv-validate-on="blur" v-validate="{regex : '^[0-9]*$'}"/> -->
						<vs-input class="data-input-table w-1/4" @focus="hoverSku = true" @blur="hoverSku = false" v-model="allSku" name="allSku" />
						<vs-input class="data-input-table w-1/4" @focus="hoverVolumetric = true" @blur="hoverVolumetric = false" @click="popupActive_all = true" v-model="allVolumetric" name="allVolumetric" data-vv-validate-on="blur" v-validate="{regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}"/>
						<vs-input class="data-input-table w-1/4" @focus="hoverWeight = true" @blur="hoverWeight = false" v-model="allWeight" name="allWeight" data-vv-validate-on="blur" v-validate="{regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}"/>

						<vs-popup classContent="popup-example" title="Volumetric Calculator" :active.sync="popupActive_all">
							<div class="volumetric-container">
								<div class="volumetric-cal-form">
										<div>
											<label class="vs-input--label">Length (cm)</label>
											<vs-input 
												class="length-text-field vx-col" 
												v-model="length" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="length" 
												data-vv-validate-on="blur" />
											<span class="text-danger text-sm vx-col">{{ errors.first('length') }}</span>
										</div>
										
										
										<div>
											<label class="vs-input--label">Height (cm)</label>
											<vs-input 
												class="height-text-field vx-col" 
												v-model="height" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="height" 
												data-vv-validate-on="blur" />
											<span class="text-danger text-sm vx-col">{{ errors.first('height') }}</span>
										</div>

										<div>
											<label class="vs-input--label">Width (cm)</label>
											<vs-input 
												class="width-text-field vx-col" 
												v-model="width" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="width" 
												data-vv-validate-on="blur"/>
											<span class="text-danger text-sm">{{ errors.first('width') }}</span>
										</div>

										<vs-button class="w-1/2 shadow-md mt-2" :disabled="!validateVolumetricForm" @click="calculateVolumetric(length,height,width)">Calculate</vs-button>
									</div>

									<div class="volumetric-img">
										<img src="@/assets/images/pages/xmas_surprise.svg" />
										<div class="h"><span>H</span></div>
										<div class="w">W</div>
										<div class="l">L</div>
									</div>
							</div>		
							</vs-popup>

						<div class="button p-3 w-1/5 mr-3 text-center font-medium rounded cursor-pointer items-center text-base text-primary border border-solid border-primary" @click="applyAll()">
              <span class="text-base text-primary text-center">Apply All</span>
						</div>
					</div>
				</div>

				<!-- Variation Summary -->
				<!-- Root Table -->
				<vs-table class="mt-10" v-if="selectedProduct.isEnableRootSetting && !selectedProduct.isEnableTreeSetting" :data="selectedProduct.variant">
						<template slot="header">
							<h4>Variation Summary Table</h4>
						</template>
						<template slot="thead">
							<vs-th>{{selectedProduct.variant[0].label}}</vs-th>
							<vs-th>Price(RM)</vs-th>
							<vs-th>Stock
							<vx-tooltip title="Sorry"
								text="Stock update can only be made from inventory management">
								<feather-icon class="vd-info vx-col cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/>
							</vx-tooltip>
							</vs-th>
							<vs-th>SKU</vs-th>
							<vs-th>Volumetric(KG)
								<vx-tooltip title="Why we need this?"
								text="Volumetric weight is to measure the bulkiness of an item in order to prevents any weightage discrepancy in future that might leads to expensive shipping charges.">
								<feather-icon class="vd-info vx-col cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/>
							</vx-tooltip>
							</vs-th>
							<vs-th>Weight(KG)</vs-th>
						</template>
			
						<template slot-scope="">
							<vs-tr v-for="(option, index) in selectedProduct.variant" :key="'d'+index">

								<vs-td :data="option.value">
									{{ option.value }}
								</vs-td>
								
								<vs-td :class="hoverPrice ? 'hover_class' : ''" :data="option.price">
									<vs-input 
									class="data-input-table w-full" 
									v-model="option.price"
									:name="option.value+' price'"
									data-vv-validate-on="blur" 
									v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}"/>
									<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${option.value+' price'}`) }}</span>
								</vs-td>
									
								<vs-td :class="hoverStock? 'hover_class' : ''" :data="option.inventory_count">
										<vs-input
										class="data-input-table w-1/2" 
										v-model="option.inventory_count"
										:name="option.label+' stock'"/>
								</vs-td>

								<vs-td :class="hoverSku ? 'hover_class' : ''" :data="option.sku">
									<vs-input class="data-input-table w-full" v-model="option.sku" />
								</vs-td>

								<vs-td :class="hoverVolumetric ? 'hover_class' : ''" :data="option.volumetric">
									<vs-input 
									class="data-input-table w-1/2" 
									v-model="option.volumetric"
									:name="option.value+' volumetric'"
									data-vv-validate-on="blur"
									v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}"/>
									<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${option.value+' volumetric'}`) }}</span>
								</vs-td>

								<vs-td :class="hoverWeight ? 'hover_class' : ''" :data="option.weight">
									<vs-input 
									class="data-input-table w-1/2" 
									v-model="option.weight"
									:name="option.value+' weight'"
									data-vv-validate-on="blur"
									v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" />
									<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${option.value+' weight'}`) }}</span>
								</vs-td>


							</vs-tr>
						</template>
				</vs-table>

				       
				<!-- Root + Tree -->
			  <vs-table v-if="selectedProduct.isEnableRootSetting && selectedProduct.isEnableTreeSetting" :data="selectedProduct.variant">
					<template slot="header">
						<h4>Variation Summary Table</h4>
					</template>
					<template slot="thead">
							<vs-th>{{selectedProduct.variant[0].label}}</vs-th>
							<vs-th>{{selectedProduct.variant[0].option[0].label}}</vs-th>
							<vs-th>Price(RM)</vs-th>
							<vs-th>Stock
							<vx-tooltip title="Sorry"
								text="Stock update can only be made from inventory management">
								<feather-icon class="vd-info vx-col cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/>
							</vx-tooltip>
							</vs-th>
							<vs-th>SKU</vs-th>
							<vs-th>Volumetric(KG)
								<vx-tooltip title="Why we need this?"
								text="Volumetric weight is to measure the bulkiness of an item in order to prevents any weightage discrepancy in future that might leads to expensive shipping charges.">
								<feather-icon class="vd-info vx-col cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/>
							</vx-tooltip>
							</vs-th>
							<vs-th>Weight(KG)</vs-th>
					</template>

					<tbody v-for="(variant,tindex) in selectedProduct.variant" :key="tindex" slot-scope="">
						<vs-tr v-for="(option, index) in variant.option" :key="index">
							<vs-td v-if="index == 0" :rowspan="variant.option.length" :data="variant.value">{{variant.value}}</vs-td>
							<vs-td :data="option.value">{{option.value}}</vs-td>
							<vs-td :class="hoverPrice ? 'hover_class' : ''" :data="option.price" >
								<vs-input 
								:name="variant.value+' '+option.value+' price'" 
								data-vv-validate-on="blur" 
								v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}"  
								class="data-input-table w-full" 
								v-model="option.price" />
							  <span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${variant.value+' '+option.value+' price'}`) }}</span>
							</vs-td>

							<vs-td :class="hoverStock? 'hover_class' : ''" :data="option.inventory_count">
									<vs-input 
									class="data-input-table w-1/2" 
									v-model="option.inventory_count"
									:name="option.label+' stock'"
									disabled/>
							</vs-td>
							
							<vs-td :class="hoverSku ? 'hover_class' : ''" :data="option.sku">
								<vs-input class="data-input-table w-full" :name="'sku '+index" v-model="option.sku" />
							</vs-td>

							<vs-td :class="hoverVolumetric ? 'hover_class' : ''" :data="option.volumetric">
								<vs-input 
								:name="variant.value+' '+option.value+' volumetric'" 
								class="data-input-table w-1/2" 
								data-vv-validate-on="blur" 
								v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
								v-model="option.volumetric" />
								<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${variant.value+' '+option.value+' volumetric'}`) }}</span>
							</vs-td>

							<vs-td :class="hoverWeight ? 'hover_class' : ''" :data="option.weight">
								<vs-input 
								:name="variant.value+' '+option.value+' weight'" 
								class="data-input-table w-1/2" 
								data-vv-validate-on="blur" 
								v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
								v-model="option.weight" />
								<span class="text-danger text-sm mt-3 vx-col">{{ errors.first(`${variant.value+' '+option.value+' weight'}`) }}</span>
							</vs-td>
						</vs-tr>
					</tbody>
				</vs-table>

				<!-- Product Image -->
				<h4 class="mt-5">Media Centre</h4>
				<!-- Image Container -->
				<!-- Cover Photo -->
				<div class="vx-row">
						<div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
								<vx-card>
										<div slot="no-body">
												<img v-if="selectedProduct.image !== null" :src="selectedProduct.image.feature.Location" alt="content-img" class="img-card card-img-top">
												<!-- <img v-else-if="selectedProduct.image.feature.Location === null" src="@/assets/images/pages/no_image.png" alt="content-img" class="img-card card-img-top"> -->
												<img v-else src="@/assets/images/pages/no_image.png" alt="content-img" class="img-card card-img-top">
										</div>
							
										<div class="flex justify-between flex-wrap">
											<input type="file" class="hidden" ref="updateCoverImage" @change="onSelectedImage(selectedProduct.image.feature.key, 'f')" accept="image/*">
											<vs-button class="mt-4 mr-2 shadow-lg" type="gradient" color="primary" @click="$refs.updateCoverImage.click()">Update</vs-button>
											<vs-button class="mt-4" type="filled" color="#b9b9b9" @click="removeImage(selectedProduct.image.feature.key, 'f')">Remove</vs-button>
										</div>
								</vx-card>
						</div>

						<template v-if="selectedProduct.image !== null && selectedProduct.image.image.length > 0">
							<div v-for="(image, index) in selectedProduct.image.image"  :key="'b'+index" class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
									<vx-card>
										<div slot="no-body">
												<img :src="image.Location" alt="content-img" class="img-card card-img-top">
										</div>
										
										<div class="flex justify-between flex-wrap">
											<input type="file" class="hidden" ref="updateImgInput" @change="onSelectedImage(image.key, 'i')" accept="image/*">
											<vs-button class="mt-4 mr-2 shadow-lg" type="gradient" color="primary" @click="$refs.updateImgInput[index].click()">Update</vs-button>
											<vs-button class="mt-4" type="filled" color="#b9b9b9" @click="removeImage(image.key, 'i')">Remove</vs-button>
										</div>
								</vx-card>
							</div>
						</template>

						<div v-for="(file, index) in fileLimit"  :key="index" class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
							<vx-card>
									<div slot="no-body">
											<img src="@/assets/images/pages/no_image.png" alt="content-img" class="img-card card-img-top">
									</div>
									
									<div class="flex justify-between flex-wrap">
										<input type="file" class="hidden" ref="updateEmptyImgInput" @change="onSelectedImage(null, 'i')" accept="image/*">
										<vs-button class="mt-4 mr-2 shadow-lg" type="gradient" color="primary" @click="$refs.updateEmptyImgInput[index].click()">Upload</vs-button>
										<vs-button class="mt-4" type="border" color="#b9b9b9" disabled>Remove</vs-button>
									</div>
							</vx-card>
						</div>
				</div>

				<div class="shipping-container">
						<div class="shipping-fee-section">
							<h3 class="shipping-section-header">Sales Information</h3>
							<div class="vx-row mt-5">
								<!-- <div class="vx-col mt-5"> -->
									<label class="vs-input--label">Free Shipping Fee</label>
									<vx-tooltip text="If you toogle this off, we will charge the shipping fee based on the shipping fee setting.">
										<feather-icon class="vx-col cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/>
									</vx-tooltip>
								<!-- </div> -->
							</div>
							<vs-switch icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check" v-model="selectedProduct.is_shipping_free" vs-value=1 style="width: 60px;">
											<span slot="on">Yes</span>
											<span slot="off">No</span>
							</vs-switch>


					<div v-if="selectedProduct.product_variant === false" class="product-price-section mt-5">
						<label class="vs-input--label">Product Price</label>
						<vx-input-group class="w-1/3 mt-3">
							<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span>RM</span>
							</div>
							</template>
							<vs-input 
							class="vx-col" 
							v-model="selectedProduct.product_price" 
							v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
							name="product price" 
							data-vv-validate-on="blur" />
						</vx-input-group> 
						<span class="text-danger text-sm mt-3 vx-col">{{ errors.first('product price') }}</span>

						<div class="mt-5">
						<label class="vs-input--label">Stock</label>
							<vs-input-number 
							class="vx-col" 
							style="width:200px;"  
							name="product stock" 
							color="#f9278e" 
							v-validate="{required: true}"
							v-model="selectedProduct.product_inventory_count"
							data-vv-validate-on="blur"/>
						<span class="text-danger text-sm mt-3 vx-col">{{ errors.first('product stock') }}</span>
						</div>
						
						<div class="mt-5">
							<vs-input 
							label="SKU"
							class="vx-col" 
							v-model="selectedProduct.product_sku"  
							name="product sku" 
							data-vv-validate-on="blur" />
						<span class="text-danger text-sm mt-3 vx-col">{{ errors.first('product sku') }}</span>
						</div>


					<div class="weight-section mt-5">
							<vs-input
								label="Weight(KG)"
								class="vx-col" 
								v-model="selectedProduct.product_weight" 
								v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
								name="weight" 
								data-vv-validate-on="blur" />
					    <span class="text-danger text-sm mt-3 vx-col">{{ errors.first('weight') }}</span>
					</div>

					<div class="volumetric-section mt-5">
						<div class="vx-row">
							<label class="vd-label vs-input--label mr-3"> Volumetric Weight (KG)</label>
							<vx-tooltip title="Why we need this?"
							text="Volumetric weight is to measure the bulkiness of an item in order to prevents any weightage discrepancy in future that might leads to expensive shipping charges.">
								<feather-icon class="vd-info vx-col cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/>
							</vx-tooltip>
							</div>
							<vs-input 
								class="vx-col" 
								v-model="selectedProduct.product_volumetric" 
								name="volumetric" 
								v-validate="{required: true}" 
								@click="popupActive=true" />
					    <span class="text-danger text-sm mt-3 vx-col">{{ errors.first('volumetric') }}</span>

							<vs-popup classContent="popup-example" title="Volumetric Calculator" :active.sync="popupActive">
							<div class="volumetric-container">
								<div class="volumetric-cal-form">
										<div>
											<label class="vs-input--label">Length (cm)</label>
											<vs-input 
												class="length-text-field vx-col" 
												v-model="length" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="length" 
												data-vv-validate-on="blur" />
											<span class="text-danger text-sm vx-col">{{ errors.first('length') }}</span>
										</div>
										
										
										<div>
											<label class="vs-input--label">Height (cm)</label>
											<vs-input 
												class="height-text-field vx-col" 
												v-model="height" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="height" 
												data-vv-validate-on="blur" />
											<span class="text-danger text-sm vx-col">{{ errors.first('height') }}</span>
										</div>

										<div>
											<label class="vs-input--label">Width (cm)</label>
											<vs-input 
												class="width-text-field vx-col" 
												v-model="width" 
												v-validate="{required: true, regex : '^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$'}" 
												name="width" 
												data-vv-validate-on="blur"/>
											<span class="text-danger text-sm">{{ errors.first('width') }}</span>
										</div>

										<vs-button class="w-1/2 shadow-md mt-2" :disabled="!validateVolumetricForm" @click="calculateVolumetric(length,height,width)">Calculate</vs-button>
									</div>

									<div class="volumetric-img">
										<img src="@/assets/images/pages/xmas_surprise.svg" />
										<div class="h"><span>H</span></div>
										<div class="w">W</div>
										<div class="l">L</div>
									</div>
							</div>		
							</vs-popup>
					</div>

						  
					</div>
					</div>
				</div>

    </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Update Product</vs-button>
    </div>


		</div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { Validator } from 'vee-validate'
import vSelect from 'vue-select'


const dict = {
  custom: {
    others: {
      required: 'Please enter the variant name',
    },
    others2: {
      required: 'Please enter the variant name',
      is_not: "Variant name cannot be the same"
		},
		
  }
}

// register custom messages
Validator.localize('en', dict);

export default {
  components: {
		VuePerfectScrollbar,    
		'v-select': vSelect

  },
  data () {
    return {
			product: {},
			selectedProduct: {},
      counterDanger: false,
			is_shipping_free: true,
			shipping_fee: '',
			weight: '',
			volumetric: '',
			popupActive: false,
			popupActive_all: false,
			product_sku: '',
			product_stock: 0,
			product_price: '',
			product_volumetric: '',
			product_weight: '',
			length: '',
			height: '',
			width: '',
			allPrice: '',
			allStock: '',
			allSku: '',
			allVolumetric: '',
			allWeight: '',
			others: '',
			others2: '',
			image: null,
			images: [],
			removeImages: [],
			sequenceImages: [],
			hoverPrice: false,
			hoverStock: false,
			hoverSku: false,
			hoverVolumetric: false,
			hoverWeight: false,
			resetPrompt: false,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
	},
	created() {
		this.$store.dispatch('product/getCategories'),
		this.$store.dispatch('product/getProducts')

		if(this.$route.params.product !== undefined){
			this.product = this.$route.params.product
		}
		
		this.sync_labelling = _.debounce(this.sync_labelling, 1000, {
      leading: false,
      trailing: true,
    })
  },
  watch: {
		product : {
			handler(newProduct) {
				this.selectedProduct = this.onSync(newProduct)
			},
			deep: true,
			immediate: true,
		}
	},
  computed: {
		getCategory() {
			return this.$store.state.product.categories
		},
		products() {
			return this.$store.state.product.products
		},
		fileLimit() {
			let maxFileLimit = 7
			if(this.selectedProduct.image === null){
				return maxFileLimit
			} else {
				return maxFileLimit - this.selectedProduct.image.image.length
			}
		},
    isFormValid () {
			if(Object.keys(this.selectedProduct).length !== 0){
				return !this.errors.any() && this.selectedProduct.name !=='' && this.selectedProduct.description !== '' && 
				this.selectedProduct.category !== null && this.modifiedCheck === true && this.check === true
			}
		},
		check() {
			if(Object.keys(this.selectedProduct).length > 0){
				if(this.selectedProduct.isEnableRootSetting === false && this.selectedProduct.isEnableTreeSetting === false){
					if(this.selectedProduct.product_price == '' || this.selectedProduct.product_stock == '' || this.selectedProduct.product_stock === 0 || this.selectedProduct.product_weight === 0
					|| this.selectedProduct.product_weight === '' || this.selectedProduct.product_volumetric === '' || this.selectedProduct.product_volumetric === 0){
						return false
					} else {
						return true
					} 
				} else {
					return true
				}
			} else return false
		},
		modifiedCheck () {
			if(Object.keys(this.selectedProduct).length !== 0){
				if(!_.isEqual(this.$store.state.product.product, this.selectedProduct)){
					return true
				} else return false
			} else return false
		},
		validateVolumetricForm () {
			return this.width !== '' && this.length !== '' && this.height !== ''
		},
		scrollbarTag () { return this.$store.getters.scrollbarTag },
	},
  methods: {
		productDiff(object, base) {
			return _.transform(object, (result, value, key) => {
				if (!_.isEqual(value, base[key])) {
					result[key] = _.isObject(value) && _.isObject(base[key]) ? difference(value, base[key]) : value
				}
			})
		},
		syncInput() {
			for(let i = 1; i < this.selectedProduct.variant.length; i++) {
				for(let j = 0; j < this.selectedProduct.variant[i].option.length; j++) {
					this.selectedProduct.variant[i].option[j].value = this.selectedProduct.variant[0].option[j].value
				}			
			}
		},
		onSelectedImage (key, type) {
			this.image = event.target.files.length > 0 ? event.target.files[0] : null

			if(key !== null && type === 'f') {
				this.imageShrinker(this.image).then((response) => {
					this.selectedProduct.image.feature.Location = response
					this.sequenceImages.splice(0,1,this.b64toBlob(response))
				})

				if(!~this.removeImages.indexOf(key)){
					this.removeImages.push(key)
				}   
			} else if(key !== null && type === 'i'){
				let index = this.selectedProduct.image.image.findIndex(x => x.key === key)
				this.imageShrinker(this.image).then((response) => {
					this.selectedProduct.image.image[index].Location = response
					this.sequenceImages.splice(index+1,1,this.b64toBlob(response))
				})

				if(!~this.removeImages.indexOf(key)){
					this.removeImages.push(key)
				}
			} else {
				if(this.selectedProduct.image === null){
					this.selectedProduct.image = {feature: {Location: this.image, key: '', image:[]}}
					this.imageShrinker(this.image).then((response) => {
						this.selectedProduct.image.feature.Location = response
						this.sequenceImages.push(this.b64toBlob(response))
					})
				} else {
					this.selectedProduct.image.image.push({Location: this.image, key: ''})
					let last_index = this.selectedProduct.image.image.length - 1
					console.log('last_index: '+last_index)
					this.imageShrinker(this.image).then((response) => {
						this.selectedProduct.image.image[last_index].Location = response
						this.sequenceImages.push(this.b64toBlob(response))
					})
				}
			}
			//POST image indicator
			// this.images.push(this.image)
			
			console.log('After adjustment sequence: '+JSON.stringify(this.sequenceImages))
			console.log('Image need to remove: '+JSON.stringify(this.removeImages))
			console.log(this.image)
			this.image = null
			// console.log('Image Array: '+this.images)
		},
		async imageShrinker(image){
			return new Promise((resolve) => {
				const reader = new FileReader()
				reader.readAsDataURL(image)
				reader.onload = e => {
					const img_element = document.createElement("img")
					img_element.src = e.target.result
					img_element.onload = event => {
						let canvas = document.createElement("canvas"),MAX_WIDTH = 500
						let scaleSize = MAX_WIDTH / event.target.width
						canvas.width = MAX_WIDTH
						canvas.height = event.target.height * scaleSize

						const ctx = canvas.getContext("2d")
						ctx.drawImage(event.target,0,0,canvas.width,canvas.height)
						let srcEncoded = ctx.canvas.toDataURL(event.target,"image/png")
						resolve(srcEncoded)
					}
				}
			})
		},
		b64toBlob(dataURI){
			let byteString = atob(dataURI.split(',')[1])
			let ab = new ArrayBuffer(byteString.length)
			let ia = new Uint8Array(ab)

			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i)
			}
			return new Blob([ab], { type: 'image/png' })
		},
		removeImage(key, type) {
			if(key !== null && type === 'f'){
				this.selectedProduct.image.feature.Location = require('@/assets/images/pages/no_image.png')
				this.sequenceImages.splice(0,1,null)

				if(!~this.removeImages.indexOf(key)){
					this.removeImages.push(key)
				}
			} else if(key !== null && type === 'i') {
				let index = this.selectedProduct.image.image.findIndex(x => x.key === key)

				this.selectedProduct.image.image[index].Location = require('@/assets/images/pages/no_image.png')
				this.sequenceImages.splice(index+1,1,null)

				if(!~this.removeImages.indexOf(key)){
					this.removeImages.push(key)
				}
				
			}
			console.log('Remove Image Array: ' +JSON.stringify(this.removeImages))
			console.log('Sequence after removal: ' +JSON.stringify(this.sequenceImages))
		},
		addRootVariant () {
			let option = []
			if(this.selectedProduct.variant[0].option.length > 0){
				this.selectedProduct.variant[0].option.forEach(o => {
					option.push({
						label: o.label,
						value: o.value,
						price: '',
						inventory_count: 0,
						sku: '',
						weight: '',
						volumetric: ''
					})
				})
				this.selectedProduct.variant.push({
				label: this.selectedProduct.variant.length > 0 
							? this.selectedProduct.variant[0].label
							: '',
				value: '',
				option
				})
			} else {
				this.selectedProduct.variant.push({
					label: this.selectedProduct.variant[0].label,
					value: '',
					price: '',
					inventory_count: 0,
					sku: '',
					volumetric: '',
					weight: '',
					option
				})
			}
			console.log(JSON.stringify(this.selectedProduct))
		},
		removeRoot(index) {
			//last root variant but still with option
			if(this.selectedProduct.variant.length === 1 && this.selectedProduct.variant[0].option.length !== 0){
				let tem_option = this.selectedProduct.variant[0].option
				temp.option.forEach(to => {
					Object.assign(to, {option: []})
				})
				this.selectedProduct.variant = temp_option
			} else {
				this.selectedProduct.variant.splice(index,1)
			}
			console.log(JSON.stringify(this.selectedProduct))
		},
		addTreeVariant () {
			this.selectedProduct.variant.forEach(v => {
				v.option.push({
					label: this.selectedProduct.variant[0].option[0].label,
					value: '',
					price: '',
					inventory_count: 0,
					sku: '',
					volumetric: '',
					weight: '',
				})
			})
			console.log(JSON.stringify(this.selectedProduct))
		},
		removeTree(index) {
			this.selectedProduct.variant.forEach(v => {
				v.option.splice(index, 1)
			})

			if(this.selectedProduct.variant[0].option.length === 0) {
				this.selectedProduct.isEnableTreeSetting = false
			}
			console.log(JSON.stringify(this.selectedProduct))
		},
		addNewRootVariant () {
			this.selectedProduct.isEnableRootSetting = true
			this.selectedProduct.variant.push({
			label: '',
			value: '',
			price: '',
			inventory_count: 0,
			sku: '',
			volumetric: '',
			weight: '',
			option: [],
			})
			console.log(JSON.stringify(this.selectedProduct))
		},
		addNewTreeVariant() {
			this.selectedProduct.isEnableTreeSetting = true
			this.selectedProduct.variant.forEach(v => {
				v.option.push({
					label: '',
					value: '',
					price: '',
					inventory_count: 0,
					sku: '',
					volumetric: '',
					weight: '',
				})
			})
			console.log(JSON.stringify(this.selectedProduct))
		},
		applyAll() {
			//Root variant
			if(this.selectedProduct.variant.length > 0 && this.selectedProduct.variant[0].option.length === 0) {
				for(let i = 0; i < this.selectedProduct.variant.length; i++){
					this.selectedProduct.variant[i].price = this.allPrice == '' ? '' : parseFloat(this.allPrice)
					// this.selectedProduct.variant[i].inventory_count = this.allStock == '' ? '' : parseInt(this.allStock)
					this.selectedProduct.variant[i].sku = this.allSku
					this.selectedProduct.variant[i].volumetric = this.allVolumetric == '' ? '' : parseFloat(this.allVolumetric)
					this.selectedProduct.variant[i].weight = this.allWeight == '' ? '' : parseFloat(this.allWeight)
				}
			// Have two variants 
			} else if (this.selectedProduct.variant.length > 0 && this.selectedProduct.variant[0].option.length > 0) {
					for(let i = 0; i < this.selectedProduct.variant.length; i ++){
						for(let j = 0; j < this.selectedProduct.variant[0].option.length; j++) {
							this.selectedProduct.variant[i].option[j].price = this.allPrice == '' ? '' : parseFloat(this.allPrice)
							// this.selectedProduct.variant[i].option[j].inventory_count = this.allStock == '' ? '' : parseInt(this.allStock)
							this.selectedProduct.variant[i].option[j].sku = this.allSku
							this.selectedProduct.variant[i].option[j].volumetric = this.allVolumetric == '' ? '' : parseFloat(this.allVolumetric)
							this.selectedProduct.variant[i].option[j].weight = this.allWeight == '' ? '' : parseFloat(this.allWeight)
						}
					}
			}
		},
		calculateVolumetric (length,height,width) {
			const vol_divider = 5000
			this.volumetric = +((length*height*width) / vol_divider).toFixed(2)

			this.popupActive = false
		},
		sync_labelling (option) {
			if(option === 1){
				for(let i = 1; i < this.selectedProduct.variant.length; i++){
					this.selectedProduct.variant[i].label = this.selectedProduct.variant[0].label
				}
			}else{
				for(let i = 0; i < this.selectedProduct.variant.length; i++){
					for(let j = 0; j < this.selectedProduct.variant[i].option.length; j++){
						this.selectedProduct.variant[i].option[j].label = this.selectedProduct.variant[0].option[0].label
					}	
				}
			}
		},
		async onSync (newProduct) {
			if(Object.keys(newProduct).length === 0) return {}
			else {
				this.sequenceImages = []
				await this.$store.dispatch('product/getProduct', newProduct)
					.then(() => {	
						this.selectedProduct =  {...this.$store.state.product.product}
						this.selectedProduct = JSON.parse(JSON.stringify(this.selectedProduct))

						if(this.selectedProduct.image !== null) {
							this.sequenceImages.push(this.selectedProduct.image.feature.key)

							if(this.selectedProduct.image.image.length > 0){
									this.selectedProduct.image.image.forEach(img => {
										this.sequenceImages.push(img.key)
									})
							}

							console.log('Initial sequence: '+JSON.stringify(this.sequenceImages))
						}
					})
					.catch(() => {
						this.$vs.notify({
						title: 'Sorry',
						text: 'The product info unable to retrieve in this moment.',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger'		
						})
					})
			}	
		},
		initOptions () {
			
		},		
		initConfirm(value) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Are you sure?',
        text: 'Would you like to clear all the variation?',
        accept: this.initEnable,
        parameters : value
      })
    },
		initEnable(value) {
			switch (value){
				case 'root':
					if(this.selectedProduct.variant[0].option.length > 0) {
						let temp_option = this.selectedProduct.variant[0].option

							temp_option.forEach(to => {
							Object.assign(to, {option: []})
						})
						this.selectedProduct.variant = temp_option
						this.selectedProduct.isEnableTreeSetting = false
					} else {
						this.selectedProduct.isEnableRootSetting = false
						this.selectedProduct.variant = []	
					}

					if(this.selectedProduct.variant.length === 0) {
						this.selectedProduct.product_variant = false
					}
					console.log(JSON.stringify(this.selectedProduct))
					break;
				case 'tree':
					this.selectedProduct.isEnableTreeSetting = false
					this.selectedProduct.variant.forEach(v => {
						Object.assign(v,{
							price: '',
							inventory_count: '',
							sku: '',
							volumetric:'',
							weight:'',
							option:[]
						})
					})
					break
			}
		},
    initValues () {
			this.product = {}
		},
    submitData () {
			this.$vs.loading()
			//Product info checking
			let keys = ['name','description','category_name','is_shipping_free','condition'], success_message = []
			let product_updated = {}

			for(let key of keys){
				if(this.product[key] !== this.selectedProduct[key]){
					if(key === 'category_name'){
						Object.assign(product_updated,{category_id : this.selectedProduct[key].id})
					}else if(key === 'is_shipping_free' || key === 'condition'){
						Object.assign(product_updated,{[key] : this.selectedProduct[key] === true ? 1 : 0})
					}else {
						Object.assign(product_updated,{[key] : this.selectedProduct[key]})
					}
				}
			}

			if(Object.keys(product_updated).length > 0){
				Object.assign(product_updated,{product_id: this.selectedProduct.id})
				this.$store.dispatch('product/updateProductInfo',product_updated)
				.then(() => {})
				.catch((err) => {
					this.$vs.notify({
						title: 'Opps, something wrong!',
						text: err.message,
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger'	
					})
				})
			}

			if(!this.selectedProduct.isEnableRootSetting && !this.product.isEnableRootSetting && !this.selectedProduct.isEnableTreeSetting && !this.product.isEnableTreeSetting){
			//Remain no variant due to different structure
			let keys = ['product_price','product_stock','product_sku','product_weight','product_volumetric'], mod = {product_id: this.selectedProduct.id}, variant = {variant_id: this.selectedProduct.variant_id,option:[]}
				for(let key of keys){
					if(this.product[key] !== this.selectedProduct[key]){
						let temp_key = key.substring(8)
						Object.assign(variant,{[temp_key] : this.selectedProduct[key]})
					}
				}
				
				Object.assign(mod, {variation: [variant]})
				console.log(JSON.stringify("mod: "+mod))

				if(Object.keys(mod).length > 1){
					this.$store.dispatch('product/updateVariant', mod)
					.then(() => {})
					.catch((err) => {
						this.$vs.notify({
							title: 'Opps, something wrong!',
							text: err.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'danger'	
						})
					})
				}
			}

			//Variant checking
			if(!_.isEqual(this.selectedProduct.variant, this.product.variant)){
				let a = _.cloneDeep(this.selectedProduct.variant), b = _.cloneDeep(this.product.variant)
				let addon = [], remove = [], modified = [], a_variant = [], b_variant = []
				
				if(this.selectedProduct.isEnableRootSetting && this.selectedProduct.isEnableTreeSetting){	
					//from single variant to two variant
					if(this.product.isEnableRootSetting && !this.product.isEnableTreeSetting){
						for(let a of a){
							for(let option of a.option){
								let temp = {
									variant_id: option.variant_id,
									price: option.price,
									sku: option.sku,
									volumetric: option.volumetric,
									weight: option.weight,
									option: [{option: 4,label: a.label,value: a.value},{option: 4,label:option.label,value:option.value}]
								}
								a_variant.push(temp)
							}
						}

						addon = _.differenceWith(a_variant,b_variant,_.isEqual)

						for(let b of b){
							remove.push({
								variant_id: b.variant_id,
								price: b.price,
								sku: b.sku,
								volumetric: b.volumetric,
								weight: b.weight,
								option: [{option: 4,label: b.label,value: b.value}]
							})
						}
					// from two variant to none
					} else if(!this.product.isEnableRootSetting && !this.product.isEnableTreeSetting){
						for(let a of a){
							for(let option of a.option){
								let temp = {
									variant_id: option.variant_id,
									price: option.price,
									sku: option.sku,
									volumetric: option.volumetric,
									weight: option.weight,
									option: [{option: 4,label: a.label,value: a.value},{option: 4,label:option.label,value:option.value}]
								}
								a_variant.push(temp)
							}
						}

						addon = _.differenceWith(a_variant,b_variant,_.isEqual)
						remove.push({
							variant_id: this.product.id,
							price: this.product.price,
							sku: this.product.sku,
							volumetric: this.product.volumetric,
							weight: this.product.weight,
							option: []
						})
					//Same two variant
					}else {
						for(let a of a){
							for(let option of a.option){
								let temp = {
									variant_id: option.variant_id,
									price: option.price,
									sku: option.sku,
									volumetric: option.volumetric,
									weight: option.weight,
									option: [{option: 4,label: a.label,value: a.value},{option: 4,label:option.label,value:option.value}]
								}
								a_variant.push(temp)
							}
						}

						for(let b of b){
							for(let option of b.option){
								let temp = {
									variant_id: option.variant_id,
									price: option.price,
									sku: option.sku,
									volumetric: option.volumetric,
									weight: option.weight,
									option: [{option: 4,label: b.label,value: b.value},{option: 4,label:option.label,value:option.value}]
								}
								b_variant.push(temp)
							}
						}

						addon = _.differenceWith(a_variant,b_variant,_.isEqual)
						remove = _.differenceWith(b_variant,a_variant,_.isEqual)
					}

					//if addon consist variant_id then move to modified
					for(let add of addon){
						if(add.hasOwnProperty('variant_id') && remove.some(re => re.variant_id === add.variant_id)){
							modified.push(add)
						}
					}

					for(let modify of modified){
						_.remove(addon, modify)
						remove.splice(remove.indexOf(remove.find(re => re.variant_id === modify.variant_id)),1)
					}
					
				}else if(this.selectedProduct.isEnableRootSetting && !this.selectedProduct.isEnableTreeSetting){
				//single variant
				//from two variant to one
					if(this.product.isEnableTreeSetting){
						for(let a of a){
							addon.push({
								price: a.price,
								sku: a.sku,
								volumetric: a.volumetric,
								weight: a.weight,
								option: [{option: 4,label: a.label,value: a.value}]
							})
						}

						for(let b of b){
							for(let option of b.option){
								let temp = {
									variant_id: option.variant_id,
									price: option.price,
									sku: option.sku,
									volumetric: option.volumetric,
									weight: option.weight,
									option: [{option: 4,label: b.label,value: b.value},{option: 4,label:option.label,value:option.value}]
								}
								b_variant.push(temp)
							}
						}

						remove = _.differenceWith(b_variant,a_variant,_.isEqual)
					//from none to one variant
					}else {
						for(let a of a){
							addon.push({
								price: a.price,
								sku: a.sku,
								volumetric: a.volumetric,
								weight: a.weight,
								option: [{option: 4, label: a.label, value: a.value}]
							})
						}
						remove.push({variant_id: this.selectedProduct.variant_id, status: 0})
					}
				}else {
					//No variant
					//from two variant to none
					if(this.product.isEnableRootSetting && this.product.isEnableTreeSetting){
						addon.push({
							price: this.selectedProduct.product_price,
							sku: this.selectedProduct.product_sku,
							volumetric: this.selectedProduct.product_volumetric,
							weight: this.selectedProduct.product_weight,
							option: []
						})

						for(let b of b){
							for(let option of b.option){
								let temp = {
									variant_id: option.variant_id,
									price: option.price,
									sku: option.sku,
									volumetric: option.volumetric,
									weight: option.weight,
									option: [{option: 4,label: b.label,value: b.value},{option: 4,label:option.label,value:option.value}]
								}
								b_variant.push(temp)
							}
						}
					remove = _.differenceWith(b_variant,a_variant,_.isEqual)
					//from one variant to none
					}else{
						addon.push({
							price: this.selectedProduct.product_price,
							sku: this.selectedProduct.product_sku,
							volumetric: this.selectedProduct.product_volumetric,
							weight: this.selectedProduct.product_weight,
							option: []
						})

						for(let b of b){
							let temp = {
									variant_id: b.variant_id,
									price: b.price,
									sku: b.sku,
									volumetric: b.volumetric,
									weight: b.weight,
									option: [{option: 4,label: b.label,value: b.value}]
							}
							b_variant.push(temp)
						}
						remove = _.differenceWith(b_variant,a_variant,_.isEqual)
					}
				}
				
				if(addon.length !== 0 || remove.length !==0 || modified.length !==0){
					let payload = {product_id: this.selectedProduct.id,variation:[]}

					if(modified.length > 0){
						modified.forEach(mo =>{
							payload.variation.push(mo)
						})
					}

					if(addon.length > 0){
						addon.forEach(ao =>{
							payload.variation.push(ao)
						})
					}

					if(remove.length > 0){
						remove.forEach(ro => {
							remove.splice(remove.indexOf(ro),1,{variant_id: ro.variant_id,status:0})
							payload.variation.push({variant_id: ro.variant_id,status:0})
						})
					}
					
					console.log('Addon: '+JSON.stringify(addon))
					console.log('Removed: '+JSON.stringify(remove))
					console.log('Modified: '+JSON.stringify(modified))
					console.log(JSON.stringify(payload))

					this.$store.dispatch('product/updateVariant', payload)
					.then(() => {})
					.catch((err) => {
						this.$vs.notify({
							title: 'Opps, something wrong!',
							text: err.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'danger'	
						})
					})
				}
			}
			//Image
			if(!_.isEqual(this.selectedProduct.image, this.product.image)){
				this.sequenceImages = this.sequenceImages.filter(i =>  i !== null)
				const post_image = this.sequenceImages.filter(i =>  typeof i === 'object')

				let index = post_image.length
				//post image, get the latest index and splice into sequenceImages
				if(index !== 0) {
					this.$store.commit('product/SET_SUBMITTED', this.selectedProduct.id)
					this.$store.dispatch('product/updateImage', post_image)
					.then((res) => {
						//patch the sequenceImages
						let slicy = res.slice(-index)
						console.log('This is slicy: '+JSON.stringify(slicy))
						for(let sli of slicy){
							this.sequenceImages.splice(this.sequenceImages.findIndex(s => typeof s === 'object'),1,sli)
						}
						console.log(this.sequenceImages)
						this.$store.dispatch('product/updateImageSequence', {product_id: this.selectedProduct.id, image: this.sequenceImages})
					})		
				}

				//remove the image key in s3
				if(this.removeImages.length > 0){
					if(this.$store.state.product.submittedProduct === null) this.$store.commit('product/SET_SUBMITTED', this.selectedProduct.id)
					this.$store.dispatch('product/removeImage',this.removeImages)
				}
			}
			this.$vs.notify({
				title: 'Success',
				text: 'Product Updated Successful!',
				iconPack: 'feather',
				icon: 'icon-check',
				color: 'success'	
			})
			this.$router.push({name: 'product'})
		}
	}
}
</script>

<style lang="scss" scoped>
.img-card{
	width: 100%;
	height: 287px;
}

.hover_class{
 background: #FEEDF6;
}
vs-table {
	text-align: center;
}
.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
	background: #FEEDF6;
}
.cross-icon {
   position:absolute;
   top:0;
	 left:200px;
}
.cross-icon-pieces{
   position:absolute;
   top:0;
	 left:450px;
}
.variant-container {
  background-color: #fff;
	border-radius: 10px;
	padding: 15px 25px;
	position: relative;
	width: 30%;
	z-index: 10;
	margin-top: 30px;
	margin-bottom: 30px;
}
.piece-container {
  background-color: #fff;
	border-radius: 10px;
	padding: 15px 25px;
	position: relative;
	width: 55%;
	z-index: 10;
	margin-top: 30px;
	margin-bottom: 30px;
}
.apply-all-container {
	display: grid;
	grid-template-rows: repeat(3,1fr);
	background-color: #fff;
	border-radius: 10px;
	padding: 15px 25px;
	position: relative;
	width: 100%;
	z-index: 10;
	margin-top: 30px;
	margin-bottom: 30px;
}

.apply-all-info {
	grid-row: 1/2;
	align-self: center;
	animation: shine 1s ease infinite;
	span{
		transform: translateY(4px);
	}
}

@keyframes shine {
	from {
		color: #626262;
	}
	to {
		color: #F9278E;
	}
}

.apply-all-label {
	display: flex;
	grid-row: 2/3;
	grid-template-columns: repeat(5,1fr);
	align-self: end;
	// grid-gap: .1rem;
	label {
		flex-wrap: wrap;
		flex: 0 0 21%;	
		grid-column: 1/4;
	}
}

.apply-all-form {
	display: flex;
	grid-row: 3/4;
	grid-template-columns: repeat(5,1fr);
	grid-gap: 2rem;
	vs-input {
			grid-column: 1/4;
	}
	div {
			grid-column: 4/5;
			margin-bottom: 5px;
	}
	.button {
		transform: translateY(-5px);
	}
}

.volumetric-section > label {
	margin-top: 5px;
}

.volumetric-container{
	display: grid;
	grid-template-columns: repeat(2,1fr);
}

.volumetric-cal-form {
	grid-column: 1/2;
}

.volumetric-img {
	grid-column: 2/3;

	img {
		width: 200px;
	}
}

.vd-label {
	transform: translateX(15px);
}

.vd-info {
	transform: translateX(5px);
}

.h{
	display: flex;
  align-items: center;
  text-align: center;
	transform: rotate(-90deg) translateY(-55px) translateX(105px);
	width: 86px;
	color: #F9278E;

	span {
		transform: rotate(90deg);
	}
}

.h:before,.h:after {
		content: '';
    flex: 1;
    border-bottom: 1px solid #F9278E;
}

.h:before{
	margin-right: .25em;
}

.h:after {
	margin-left: .25em;
}

.w {
	display: flex;
  align-items: center;
  text-align: center;
	transform: skewY(35deg) translateY(-45px);
	width: 55px;
	color: #F9278E;
	font-size: 0.8rem;
}

.w:before,.w:after {
		content: '';
    flex: 1;
    border-bottom: 1px solid #F9278E;
}

.w:before{
	margin-right: .25em;
}

.w:after {
	margin-left: .25em;
}

.l {
	display: flex;
  align-items: center;
  text-align: center;
	transform: skewY(-10deg) translateY(-40px) translateX(80px);
	width: 120px;
	color: #F9278E;
}

.l:before,.l:after {
		content: '';
    flex: 1;
    border-bottom: 1px solid #F9278E;
}

.l:before{
	margin-right: .25em;
}

.l:after {
	margin-left: .25em;
}

.img-container {
	background-color: #fff;
	border-radius: 10px;
	padding: 15px 25px;
	position: relative;
	width: 100%;
	z-index: 10;
	margin-top: 30px;
	margin-bottom: 30px;
}
.media-section {
	display: flex;
	flex-wrap: wrap;
	.upload {
		flex: 0 0 21%;	
	}
}

.shipping-container {
    display: grid;
}
.shipping-fee-section {
	  background-color: #fff;
    border-radius: 10px;
    padding: 15px 25px;
    position: relative;
    width: 100%;
    z-index: 10;
    margin-top: 30px;
    margin-bottom: 30px;
		grid-template-rows: repeat(4,1fr);
		grid-template-areas: 
		"shipping-section-header
		 shipping-fee-section ";
}

.shipping-section-header {
	grid-area: shipping-section-header;
}

.data-input-table {
	outline: none !important; 
	border-style: none !important;
}


.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    // height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
